import Vue from 'vue';
import Contact from '~/pages/contact.vue';
import RasylvaApi from '~/plugins/rasylva-api';
import createStore from '~/store';

Vue.use(RasylvaApi);

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('contact-wrapper')) {
    new Vue({
      store: createStore(),
      render: (h) => h(Contact),
    }).$mount('#contact-wrapper');
  }
});
